import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CstrService from "./cstrService"
import FormList from 'base/FormList'

export default function CstrList() {

    const [service] = useState(() => new CstrService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_cstr',
        dsName: 'descricao_cstr',
        mainField: { name: 'descricao_cstr', label: '' },
        advFields: [
            { name: 'codigo_cstr', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'codigo_cstr', label: 'Código', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_cstr" sortable header="Código"></Column>
            <Column field="descricao_cstr" sortable header="Descrição" style={{ whiteSpace: 'normal' }}></Column>
        </FormList >
    )
}
